import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";

interface DeescalationStrategiesSectionProps {
  values: string[];
  otherValue: string;
  onCheckboxChange: (value: string, checked: boolean) => void;
  onOtherChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const OPTIONS = [
  "Provide clear direction with short, simple phrases",
  "Provide simple and reasonable choices, setting limits",
  "Use an open posture and ensure empty hands can be seen",
  "Sit or kneel at the level of the student",
  "Maintain a respectful distance, showing concern and empathy",
  "Calmly direct the use of calming strategies such as a calming corner or squeeze ball",
  "Allow venting in a safe way, removing the audience while ensuring supervision",
  "Assess threatening behaviour and seek help if needed",
  "Calmly direct a purposeful errand, e.g. run a message to neighbouring class",
  "Gently encourage use of known self-calming strategies",
  "Engage the 'thinking brain' by asking them to take a breath or find the colour blue",
  'Explain that desired behaviour will lead to desired outcome, e.g. "When you sit down, I can help you."',
];

export const DeescalationStrategiesSection: React.FC<
  DeescalationStrategiesSectionProps
> = ({ values, otherValue, onCheckboxChange, onOtherChange, className }) => (
  <CollapsibleFormSection
    title="Select/describe appropriate staff responses at this stage:"
    className={className}
  >
    <div className="form-group checkbox-group brp-checkbox-group">
      {OPTIONS.map((option) => {
        const isSelected = values.includes(option);
        return (
          <label
            key={option}
            className={`checkbox-item brp-checkbox-item ${
              isSelected ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onCheckboxChange(option, e.target.checked)}
            />
            <span className="checkbox-custom brp-checkbox-custom"></span>
            <span className="checkbox-label">{option}</span>
          </label>
        );
      })}
    </div>
    <div className="brp-wide-input-container" style={{ marginTop: 16 }}>
      <label
        className="other-input-label"
        htmlFor="deescalationStrategiesOther"
      >
        Other:
      </label>
      <input
        type="text"
        id="deescalationStrategiesOther"
        name="deescalationStrategiesOther"
        value={otherValue}
        onChange={onOtherChange}
        className="other-input brp-wide-input"
      />
    </div>
  </CollapsibleFormSection>
);
